(() => {
  // ✅ Páginas donde quieres el fondo animado (handles)
  // Cambia/añade handles según tus URLs:
  // /pages/contacto -> "contacto"
  // /blogs/noticias -> NO es page handle, se controla por template (abajo)
  const PAGE_HANDLES = new Set(["contacto", "seguimiento-de-mi-paquete", "seguimiento-de-mi-paquete-1", "seguimiento"]);

  const body = document.body;

  // Detectores por template/clases de Shopify
  const isBlog = body.classList.contains("template-blog") || body.classList.contains("template-article");
  const isPage = body.classList.contains("template-page");
  const pageHandle = body.getAttribute("data-page-handle");

  // Activar solo en:
  // - Blog (listado + artículo)
  // - Páginas concretas (contacto/seguimiento/etc.)
  const shouldEnable = isBlog || (isPage && pageHandle && PAGE_HANDLES.has(pageHandle));

  if (!shouldEnable) return;

  // Marca el body para aplicar CSS solo aquí
  body.classList.add("leaf-bg");

  // Crea la capa
  const layer = document.createElement("div");
  layer.className = "leaf-fall-layer";
  layer.setAttribute("aria-hidden", "true");
  document.body.appendChild(layer);

  const MAX = window.matchMedia("(max-width: 768px)").matches ? 18 : 28;

  function rand(min, max){ return Math.random() * (max - min) + min; }

  for (let i = 0; i < MAX; i++){
    const el = document.createElement("span");
    el.className = "leaf";

    const size = rand(16, 40); // tamaño hojas
    const x = rand(0, 100);    // posición horizontal (%)
    const drift = rand(-30, 30); // deriva en px
    const opacity = rand(0.18, 0.55);
    const dur = rand(9, 18);     // duración caída
    const delay = rand(-18, 0);  // para que no empiecen todas a la vez
    const wobble = rand(2.8, 5.4);
    const sway = rand(-18, 18);
    const rot = rand(0, 360);

    el.style.setProperty("--s", `${size}px`);
    el.style.setProperty("--x", `${x}vw`);
    el.style.setProperty("--dr", `${drift}px`);
    el.style.setProperty("--o", opacity);
    el.style.setProperty("--d", `${dur}s`);
    el.style.setProperty("--w", `${wobble}s`);
    el.style.setProperty("--sw", `${sway}px`);
    el.style.setProperty("--r", `${rot}deg`);
    el.style.animationDelay = `${delay}s`;

    layer.appendChild(el);
  }
})();